import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EduContentBookInterface, Link, LinkInterface } from '@campus/dal';
import { ENVIRONMENT_API_TOKEN } from '@campus/environment';
import { Observable } from 'rxjs';
import { LinkServiceInterface } from './link.service.interface';
import { WINDOW } from '@campus/browser';

@Injectable({
  providedIn: 'root',
})
export class LinkService implements LinkServiceInterface {
  private router = inject(Router);
  private environment = inject(ENVIRONMENT_API_TOKEN);
  private httpClient = inject(HttpClient);

  private apiBase = this.environment.APIBase;
  private entity = null;
  private entityKey = null;

  constructor(@Inject(WINDOW) private window: Window) {}

  public forBook(book: EduContentBookInterface): LinkServiceInterface {
    this.entityKey = 'bookId';
    this.entity = book;

    return this;
  }

  public createUrl(link?: LinkInterface, activatedRoute?: ActivatedRoute): string {
    const queryParams = {};
    if (link?.type === 'api') return this.createApiUrl(link);

    if (!link && !this.entity) {
      throw new Error('Please provide a link or an entity to create a url.');
    }

    if (this.entityKey) {
      queryParams[this.entityKey] = this.entity.id;
    }
    if (link) {
      return link.url;
    }

    return this.router.createUrlTree([this.entity?.id], { queryParams, relativeTo: activatedRoute }).toString();
  }

  createApiUrl(link: LinkInterface): string {
    return (
      this.apiBase +
      '/api/' +
      link.url
        .replace(':id', link.id.toString())
        .replace(`:entityKey`, `${this.entityKey}=${this.entity?.id?.toString()}`)
    );
  }

  createLink(link: Partial<LinkInterface>): Observable<{ linkId: number }> {
    const url = `${this.apiBase}/api/links/create-link`;
    return this.httpClient.post<number>(url, { link }, { withCredentials: true }) as any;
  }

  deleteLink(link: LinkInterface): Observable<{ deleteResult: number }> {
    const url = `${this.apiBase}/api/links/delete-link/${link.id}`;
    return this.httpClient.delete<{ deleteResult: number }>(url, { withCredentials: true }) as any;
  }

  handleLink(link: Link): void {
    switch (link.type) {
      case 'api': {
        const url = this.createApiUrl(link);
        this.window.open(url);
        return;
      }
      case 'internal': {
        this.router.navigateByUrl(link.link);
        return;
      }
      case 'external': {
        this.window.open(link.link, '_blank');
        return;
      }
    }
  }
}
